<div
  class="sidebar-area bg-white box-shadow"
  [ngClass]="{ active: isToggled }"
  [class.dark-sidebar]="themeService.isSidebarDark()"
  [class.right-sidebar]="themeService.isRightSidebar()"
  [class.hide-sidebar]="themeService.isHideSidebar()"
>
  <div class="logo bg-white">
    <a routerLink="/" class="d-flex align-items-center">
      <img src="assets/img/branzee_logo.png" class="app-logo" alt="logo" width="190" />
    </a>
  </div>
  <div class="burger-menu" (click)="toggle()" [ngClass]="{ active: isToggled }">
    <span class="top-bar"></span>
    <span class="middle-bar"></span>
    <span class="bottom-bar"></span>
  </div>
  <ng-scrollbar visibility="hover" style="height: 100vh">
    <div class="sidebar-inner">
      <div class="sidebar-menu">
        <!-- Grouped "square" cards -->
        <ng-container *ngIf="currentUser">
          <ng-container *ngFor="let group of menuGroups">
            <div
              *ngIf="showGroup(group)"
              class="sidebar-group"
              [class.sidebar-group--locked]="group.locked"
            >
              <!-- group label -->
              <div class="sidebar-group-header">
                <i *ngIf="group.icon" class="{{ group.icon }}"></i>
                <span class="sidebar-group-title" [translate]="group.translate">{{ group.title }}</span>
              </div>

              <!-- group items -->
              <div class="sidebar-group-body">
                <mat-accordion>
                  <ng-container *ngFor="let item of group.children">
                    <!-- collapsible -->
                    <ng-container *ngIf="item.type == 'collapsible' && (item.permissions && item.permissions.length > 0 ? showElement(item) : false || item.permissions == undefined)">
                      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = true" *ngIf="!item.hidden">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            <i class="{{ item.icon }}"></i>
                            <span class="title" [translate]="item.translate">{{ item.title }}</span>
                            <span *ngIf="item.badge" class="badge">{{ item.badge }}</span>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                          <ng-container *ngFor="let item of item.children">
                            <!-- item with router url -->
                            <li
                              *ngIf="item.type == 'item' && (item.permissions && item.permissions.length > 0 ? showElement(item) : false || item.permissions == undefined) && item.url && !item.externalUrl"
                              class="sidemenu-item"
                            >
                              <a
                                [ngClass]="{ disabled: item.disabled === true }"
                                [routerLink]="item.openInNewTab ? [] : [item.url]"
                                [routerLinkActive]="!item.openInNewTab ? 'active' : ''"
                                [routerLinkActiveOptions]="{ exact: true }"
                                class="sidemenu-link"
                                [translate]="item.translate"
                              >
                                {{ item.title }}
                              </a>
                            </li>
                            <!-- item with external url -->
                            <li
                              *ngIf="item.type == 'item' && (item.permissions && item.permissions.length > 0 ? showElement(item) : false || item.permissions == undefined) && item.url && item.externalUrl"
                              class="sidemenu-item"
                            >
                              <a [ngClass]="{ disabled: item.disabled === true }" [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'" class="sidemenu-link" [translate]="item.translate">
                                {{ item.title }}
                              </a>
                            </li>
                          </ng-container>
                        </ul>
                      </mat-expansion-panel>
                    </ng-container>

                    <!-- single item (locked groups always render their items as a teaser) -->
                    <ng-container *ngIf="item.type == 'item' && (group.locked || (item.permissions && item.permissions.length > 0 ? showElement(item) : false || item.permissions == undefined))">
                      <a
                        *ngIf="!item.hidden && item.url && !item.externalUrl"
                        [ngClass]="{ disabled: item.disabled === true || item.locked === true }"
                        [routerLink]="item.locked ? null : [item.url]"
                        [target]="item.openInNewTab ? '_blank' : '_self'"
                        [routerLinkActive]="!item.openInNewTab && !item.locked ? 'active' : ''"
                        [routerLinkActiveOptions]="{ exact: true }"
                        class="sidebar-menu-link"
                      >
                        <i class="{{ item.icon }}"></i>
                        <span class="title" [translate]="item.translate">{{ item.title }}</span>
                      </a>

                      <a
                        *ngIf="!item.hidden && item.url && item.externalUrl"
                        [ngClass]="{ disabled: item.disabled === true }"
                        [href]="item.url"
                        [target]="item.openInNewTab ? '_blank' : '_self'"
                        class="sidebar-menu-link"
                      >
                        <i class="{{ item.icon }}"></i>
                        <span class="title" [translate]="item.translate">{{ item.title }}</span>
                      </a>
                    </ng-container>
                  </ng-container>
                </mat-accordion>
              </div>

              <!-- lock overlay for upcoming/locked groups -->
              <div class="sidebar-group-lock" *ngIf="group.locked">
                <i class="ri-lock-2-line"></i>
                <span class="sidebar-group-lock-label">{{ group.lockedLabel }}</span>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <!--/ Grouped "square" cards -->
      </div>
    </div>
  </ng-scrollbar>
</div>
